import { render, staticRenderFns } from "./sorotecascontainers.vue?vue&type=template&id=0e511569&"
import script from "./sorotecascontainers.vue?vue&type=script&lang=js&"
export * from "./sorotecascontainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports